import { useEffect } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

const ESIGENZE = [["protezione", "Protezione"], ["risparmio_investimento", "Risparmio / Investimento"], ["previdenza", "Previdenza"]];
const DESTINATARI = [["se_stesso_attivita", "Sé stesso / Attività"], ["nucleo_persone_care", "Nucleo familiare / persone care"], ["collettivita", "Collettività"]];
const BISOGNI = [["premorienza", "Premorienza"], ["redditi_finanziamenti", "Redditi / Finanziamenti"], ["salute", "Cura e salute"], ["beni", "Beni"], ["veicoli", "Veicoli"], ["patrimonio", "Tenore di vita / Patrimonio"]];

// Sottoinsiemi per persone giuridiche (P.IVA): esclude i bisogni tipici delle persone fisiche
const ESIGENZE_BUSINESS = [["protezione", "Protezione"], ["risparmio_investimento", "Risparmio / Investimento"]];
const DESTINATARI_BUSINESS = [["se_stesso_attivita", "Attività d'impresa"], ["collettivita", "Collettività"]];
const BISOGNI_BUSINESS = [["beni", "Beni"], ["redditi_finanziamenti", "Redditi / Finanziamenti"], ["veicoli", "Veicoli"], ["patrimonio", "Tenore di vita / Patrimonio"]];

// Pre-flag di default (modificabili dopo l'intervista col cliente): Protezione · Sé stesso/Attività ·
// Tenore di vita/Patrimonio · Adeguato ai bisogni.
const DEFAULT_ESIGENZE = ["protezione"];
const DEFAULT_DESTINATARI = ["se_stesso_attivita"];
const DEFAULT_BISOGNI = ["patrimonio"];

export const iddValid = (v) => !!v && (v.adeguatezza === "adeguato" || v.adeguatezza === "non_adeguato");

function Group({ title, options, selected, onToggle, prefix }) {
  return (
    <div>
      <p className="mb-1.5 text-xs font-medium uppercase tracking-wide text-forest/60">{title}</p>
      <div className="flex flex-wrap gap-x-4 gap-y-1.5">
        {options.map(([k, label]) => (
          <label key={k} className="flex items-center gap-2 text-sm">
            <Checkbox data-testid={`${prefix}-${k}`} checked={(selected || []).includes(k)} onCheckedChange={() => onToggle(k)} />
            <span className="text-forest">{label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}

export function IddDeclaration({ value, onChange, testidPrefix = "idd", businessOnly = false, hideAdeguatezza = false }) {
  const v = value || { esigenze: [], destinatari: [], bisogni: [], adeguatezza: null, nota: "" };
  const set = (patch) => onChange({ ...v, ...patch });
  const toggle = (field, k) => {
    const arr = v[field] || [];
    set({ [field]: arr.includes(k) ? arr.filter((x) => x !== k) : [...arr, k] });
  };
  const esigenze = businessOnly ? ESIGENZE_BUSINESS : ESIGENZE;
  const destinatari = businessOnly ? DESTINATARI_BUSINESS : DESTINATARI;
  const bisogni = businessOnly ? BISOGNI_BUSINESS : BISOGNI;

  // Pre-flag di default al primo mount (value non ancora valorizzato). Restano modificabili.
  useEffect(() => {
    if (value == null) {
      const keep = (codes, opts) => codes.filter((c) => opts.some(([k]) => k === c));
      onChange({
        esigenze: keep(DEFAULT_ESIGENZE, esigenze),
        destinatari: keep(DEFAULT_DESTINATARI, destinatari),
        bisogni: keep(DEFAULT_BISOGNI, bisogni),
        adeguatezza: hideAdeguatezza ? null : "adeguato",
        nota: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="space-y-3">
      <Group title="Esigenze assicurative" options={esigenze} selected={v.esigenze} onToggle={(k) => toggle("esigenze", k)} prefix={`${testidPrefix}-esi`} />
      <Group title="Destinatari" options={destinatari} selected={v.destinatari} onToggle={(k) => toggle("destinatari", k)} prefix={`${testidPrefix}-dest`} />
      <Group title="Aree di bisogno" options={bisogni} selected={v.bisogni} onToggle={(k) => toggle("bisogni", k)} prefix={`${testidPrefix}-bis`} />
      {!hideAdeguatezza && (
        <>
          <div>
            <p className="mb-1.5 text-xs font-medium uppercase tracking-wide text-forest/60">Valutazione di adeguatezza</p>
            <div className="flex flex-wrap gap-2">
              {[["adeguato", "Adeguato ai bisogni"], ["non_adeguato", "Non adeguato"]].map(([k, label]) => (
                <button key={k} type="button" data-testid={`${testidPrefix}-${k}`} onClick={() => set({ adeguatezza: k })}
                  className={`rounded-full border px-4 py-1.5 text-sm font-medium transition-colors ${
                    v.adeguatezza === k ? "border-forest bg-forest text-white" : "border-border text-forest/70 hover:bg-sage"}`}>
                  {label}
                </button>
              ))}
            </div>
          </div>
          {v.adeguatezza && (
            <Input data-testid={`${testidPrefix}-nota`} placeholder="Nota (facoltativa)" value={v.nota || ""} onChange={(e) => set({ nota: e.target.value })} />
          )}
        </>
      )}
    </div>
  );
}
